import { Grid, Box, Typography } from "@material-ui/core";
import { WHITE, GREEN_PRIMRY, BLUE_PRIMARY } from "../utils/const";
import Loading from "../components/loading";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import useCustomState from "../hooks/State";
import { useMountAPI } from "../hooks/APICall";
import Call from "../service/API";
import InfoIcon from "@material-ui/icons/Info";
import moment from "jalali-moment";
import { Link } from "react-router-dom";

const AdminInfo = (props) => {
  const adminId = props.match.params.adminId;

  const isLoading = useCustomState(true);
  const adminInfo = useCustomState({});

  const accessIsLoading = useCustomState(true);
  const accessInfo = useCustomState({});

  const adminUtils = {
    isLoading: isLoading,
    adminInfo: adminInfo,
    adminId: adminId,
  };

  const accessUtils = {
    isLoading: accessIsLoading,
    info: accessInfo,
    adminId: adminId,
  };

  useMountAPI(fetchAdminInfo, adminUtils);
  useMountAPI(fetchAccessInfo, accessUtils);

  const renderInfoTable = () => {
    if (isLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      const description = adminInfo.value.info.description
        ? adminInfo.value.info.description
        : "وارد نشده";
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableBody>
              <TableRow>
                <TableCell align={"center"}>نام: </TableCell>
                <TableCell align={"center"}>{adminInfo.value.name}</TableCell>
                <TableCell align={"center"}>نام خانوادگی: </TableCell>
                <TableCell align={"center"}>
                  {adminInfo.value.lastname}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align={"center"}>شماره تلفن: </TableCell>
                <TableCell align={"center"}>
                  {convertNumbers(adminInfo.value.phoneNumber)}
                </TableCell>
                <TableCell align={"center"}>{""}</TableCell>
                <TableCell align={"center"}>{""}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>توضیحات: </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{description}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderAdminInfo = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>اطلاعات مدیر</Typography>
          </Box>
          {renderInfoTable()}
        </Grid>
      </>
    );
  };

  const renderAccessabilityTable = () => {
    if (isLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      if (adminInfo.value.permissions.includes("Base")) {
        return (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography>
              <span>این مدیر به </span>
              <span style={{ color: GREEN_PRIMRY, fontWeight: "bold" }}>
                {"تمام بخش ها "}
              </span>
              <span>دسترسی دارد.</span>
            </Typography>
          </Grid>
        );
      } else {
        if (accessIsLoading.value) {
          return (
            <div
              style={{ position: "relative", width: "100%", height: "180px" }}
            >
              <Loading />
            </div>
          );
        } else {
          return (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginBottom: "16px" }}
              >
                <Typography>این مدیر به پروژه های زیر دسترسی دارد:</Typography>
              </Grid>
              <TableContainer
                component={Paper}
                style={{
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                <Table sx={{ maxWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>نام پروژه</TableCell>
                      <TableCell>محل انجام</TableCell>
                      <TableCell>تاریخ شروع</TableCell>
                      <TableCell>جزئیات</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {accessInfo.value.projects.map((project, idx) => {
                      return (
                        <TableRow>
                          <TableCell>{convertNumbers(idx + 1)}</TableCell>
                          <TableCell>{project.name}</TableCell>
                          <TableCell>{project.location}</TableCell>
                          <TableCell>
                            {convertNumbers(
                              moment(project.startDate)
                                .locale("fa")
                                .format("YYYY/MM/DD")
                            )}
                          </TableCell>
                          <TableCell>
                            <Link to={"/admin/project-dash/" + project.id}>
                              <InfoIcon
                                style={{
                                  cursor: "pointer",
                                  color: BLUE_PRIMARY,
                                }}
                              />
                            </Link>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          );
        }
      }
    }
  };

  const renderAccessabilityInfo = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              اطلاعات دسترسی
            </Typography>
          </Box>
          {renderAccessabilityTable()}
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          style={{
            maxWidth: "250px",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>
            مشاهده اطلاعات مدیر
          </Typography>
        </Box>
        <Grid container style={{ paddingTop: "48px", paddingBottom: "48px" }}>
          {renderAdminInfo()}
          {renderAccessabilityInfo()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminInfo;

const processAdminInfo = (admin) => {
  const processedInfo = {
    id: admin.admin_id,
    name: admin.admin_name,
    lastname: admin.admin_lastname,
    phoneNumber: admin.admin_phone,
    permissions: admin.admin_permissions,
    registeredAt: admin.admin_create_date,
    info: admin.other_information,
  };
  return processedInfo;
};

const fetchAdminInfo = (utils) => {
  const isLoading = utils.isLoading;
  const adminInfo = utils.adminInfo;
  const adminId = utils.adminId;

  const data = {
    other_admin_id: adminId,
  };

  Call("POST", "admins/admin/getOne", data).then((response) => {
    // console.log("admin Info: ", response);
    if (response.data.code === 200) {
      adminInfo.handleChange(processAdminInfo(response.data.data));
    }
    isLoading.handleChange(false);
  });
};

const processProjects = (projects) => {
  const processedProjects = [];
  if (!projects) {
    return processedProjects;
  } else {
    projects.map((p) => {
      const data = {
        contractNumber: p.water_meter_project_contract_number,
        files: p.water_meter_project_files,
        id: p.water_meter_project_id,
        name: p.water_meter_project_name,
        startDate: p.water_meter_project_start_date,
        location: p.water_meter_project_title,
      };
      processedProjects.push(data);
    });
    return processedProjects;
  }
};

const processAccessInfo = (info, adminId) => {
  const results = {};
  let adminInfo = info.filter((inf) => inf.admin_id === adminId);
  if (adminInfo.length === 0) {
    return results;
  } else {
    adminInfo = adminInfo[0];
    results.id = adminInfo.admin_id;
    results.name = adminInfo.admin_name;
    results.phoneNumber = adminInfo.admin_phone;
    results.projects = processProjects(adminInfo.middle_admin_project_info);
  }
  return results;
};

const fetchAccessInfo = (utils) => {
  const isLoading = utils.isLoading;
  const info = utils.info;
  const adminId = utils.adminId;

  Call("POST", "middle/admin/getAll", null).then((response) => {
    // console.log("middle admins: ", response);
    if (response.data.code === 200) {
      info.handleChange(processAccessInfo(response.data.data, adminId));
    }
    isLoading.handleChange(false);
  });
};
